import { FC } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

//!STYLE
import s from "./assets/cardResult.module.css";

interface Props {
  res: any;
  resWithAnswer: any;
}
const CardResult: FC<Props> = ({ res, resWithAnswer }) => {
  return (
    <div className={s.body}>
      <h4 className={s.question}>
        <Latex>
          {res?.question?.title
            ? res?.question?.title
                ?.replaceAll("amp;", "")
                ?.replaceAll("<br />", "")
            : ""}
        </Latex>
      </h4>

      <h5>Votre réponse :</h5>
      <div
        className={`${s.cardResult} ${
          res?.answer?.isCorrect ? `${s.isCorrect}` : `${s.isNoCorrect}`
        }`}
      >
        <span>
          <Latex>
            {res?.answer?.title
              ? res?.answer?.title
                  ?.replaceAll("amp;", "")
                  ?.replaceAll("<br />", "")
              : ""}
          </Latex>
        </span>
      </div>


      <h5 style={{ marginTop: "3px" }}>Bonne réponse :</h5>
      <div
        className={`${s.cardResult} ${
          true === true ? `${s.isCorrect}` : `${s.isNoCorrect}`
        }`}
      >
        <span>
          <Latex>
            {resWithAnswer?.title
              ? resWithAnswer?.title
                  ?.replaceAll("amp;", "")
                  ?.replaceAll("<br />", "")
              : ""}
          </Latex>
        </span>
      </div>
    </div>
  );
};

export default CardResult;
